import { Button, ModalIsland } from "@saviynt/design-system";
import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";

interface TooManyItemsSelectedModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  count: number;
}

export default function TooManyItemsSelectedModal({
  isOpen,
  setIsOpen,
  count,
}: TooManyItemsSelectedModalProps) {
  const intl = useIntl();
  return (
    <ModalIsland
      kind="critical"
      alertTitle={intl.formatMessage({
        defaultMessage: "Too many items selected",
        description:
          "Alert title when too many items are selected for ticket creation",
        id: "wOakLY",
      })}
      alertSubtitle={intl.formatMessage(
        {
          defaultMessage:
            "You selected more than {count} records. Please reduce your selection and try again.",
          description:
            "Alert subtitle when too many items are selected for ticket creation",
          id: "gr+ogO",
        },
        {
          count,
        },
      )}
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      primaryButton={
        <Button type="button" kind="outlined" onClick={() => setIsOpen(false)}>
          {intl.formatMessage({
            defaultMessage: "Ok, Got It",
            description:
              "Button text when too many items are selected for ticket creation",
            id: "ql/gsB",
          })}
        </Button>
      }
    />
  );
}
